import { Component } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';

@Component({
  selector: 'app-capture-history-item-type-estimated-value-updated',
  templateUrl: './capture-history-item-type-estimated-value-updated.component.html',
  styleUrls: ['./capture-history-item-type-estimated-value-updated.component.scss'],
  imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent, CurrencyPipe]
})
export class CaptureHistoryItemTypeEstimatedValueUpdatedComponent extends CaptureHistoryItemTypeBaseComponent {
  get title() {
    return 'Estimated Value';
  }

  get estimatedValue() {
    return this.captureHistoryItem.data?.estimatedValue;
  }

  // Only present for capture admins with the manage_product role
  get methodDescription() {
    return this.captureHistoryItem.data?.estimatedValueMethodDescription;
  }
}
